<p>
    <b>Please Login</b><br />
    You can login using your "<strong>AIM Client Center</strong>" credentials.
</p>

<aim-button qa="login" (click)="login.emit()" [text]="'Login'"></aim-button>
